import { findElement, findElementAll } from "../utils/element-handlers.utils";

interface NobuFormControlElementSet {
    messageElement?: HTMLElement | null,
    errorMessageElement?: HTMLElement | null
}

type NobuFormControlElements = {
    [fieldName: string]: NobuFormControlElementSet
};

class NobuFormUI {
    private fieldNames: string[];
    private controlElements: NobuFormControlElements;
    private formErrorMessageElement: HTMLElement | null;

    constructor(
        formElement: HTMLFormElement,
        fieldsToUse?: string[]
    ) {
        const formData = new FormData(formElement);
        const fieldNames: string[] = fieldsToUse || Array.from(formData.keys());
        const controlElements: NobuFormControlElements = {};

        findElementAll('.n-form-control', formElement).forEach(formControlElement => {
            for (let i = 0; i < fieldNames.length; i++) {
                const fieldElement = findElement('[name="' + fieldNames[i] + '"]', formControlElement);

                if (fieldElement) {
                    controlElements[fieldNames[i]] = {
                        messageElement: findElement('.n-form-control-message', formControlElement),
                        errorMessageElement: findElement('.n-form-control-message.n-form-error', formControlElement)
                    };

                    return;
                }
            }
        });

        if (fieldsToUse) {
            const processedFieldNameList = Object.keys(controlElements);

            fieldNames.forEach(fieldName => {
                const fieldIndex = processedFieldNameList.indexOf(fieldName);

                if (fieldIndex === -1) {
                    fieldNames.splice(fieldIndex, 1);
                    console.warn('Field not found: "' + fieldName + '". Removed from list.');
                }
            });
        }

        this.fieldNames = fieldNames;
        this.controlElements = controlElements;
        this.formErrorMessageElement = findElement('.n-form-message.n-form-error', formElement);
    }

    public setFieldError(fieldName: string, fieldErrorMessage: string): void {
        if (this.fieldNames.indexOf(fieldName) === -1) {
            console.error('Cannot set error of invalid field with name "' + fieldName + '"')
            return;
        }

        const controlElementSet = this.controlElements[fieldName];

        if (controlElementSet) {
            if (controlElementSet.errorMessageElement) {
                controlElementSet.errorMessageElement.innerHTML = fieldErrorMessage;
            }
        }
    }

    public setFormError(formErrorMessage: string) {
        if (this.formErrorMessageElement) {
            this.formErrorMessageElement.innerHTML = formErrorMessage;
            this.formErrorMessageElement.style.display = 'block';
        }
    }

    public clearAllFieldErrors() {
        for (let i = 0; i < this.fieldNames.length; i++) {
            const controlElementSet = this.controlElements[this.fieldNames[i]];

            if (controlElementSet) {
                if (controlElementSet.errorMessageElement) {
                    controlElementSet.errorMessageElement.innerHTML = '';
                }
            }
        }

        if (this.formErrorMessageElement) {
            this.formErrorMessageElement.style.display = 'none';
            this.formErrorMessageElement.innerHTML = '';
        }
    }
}

export default NobuFormUI;
